import { render } from "./AppointmentQualification.vue?vue&type=template&id=b7c1348c&ts=true"
import script from "./AppointmentQualification.vue?vue&type=script&lang=ts"
export * from "./AppointmentQualification.vue?vue&type=script&lang=ts"

import "./AppointmentQualification.vue?vue&type=style&index=0&id=b7c1348c&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__